const requiredEnvVars = [
  'REACT_APP_TO_ADDRESS',
  'REACT_APP_ADMIN_ADDRESS', 
  'REACT_APP_API_URL',
  'REACT_APP_ADMIN_URL',
  'REACT_APP_TRANSACTION_API',
  'REACT_APP_ACCOUNT_DETAILS',
  'REACT_APP_ACCOUNTV2_DETAILS',
  'REACT_APP_TRONSGRID_API_KEY',
  'REACT_APP_TRONSCAN_API_KEY',
  'REACT_APP_ENVIRONMENT'
];

export const validateEnv = () => {
  const missingVars = requiredEnvVars.filter((envVar) => !process.env[envVar]);

  if (missingVars.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missingVars.join(
        ', '
      )}. Please check your .env file.`
    );
  }

  // Validate API key format
  if (process.env.REACT_APP_TRONGRID_API_KEY && 
      !/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(process.env.REACT_APP_TRONGRID_API_KEY)) {
    console.warn('TRONGRID_API_KEY format appears invalid');
  }

  // Validate URLs
  const urlVars = [
    'REACT_APP_API_URL',
    'REACT_APP_ADMIN_URL', 
    'REACT_APP_TRANSACTION_API',
    'REACT_APP_ACCOUNT_DETAILS',
    'REACT_APP_ACCOUNTV2_DETAILS'
  ];

  urlVars.forEach(varName => {
    const value = process.env[varName];
    if (value && !value.startsWith('http')) {
      console.warn(`${varName} should start with http:// or https://`);
    }
  });

  return true;
};
